import type {
  MmkCategory,
  MmkItem,
  PersonalCardApi,
  PersonalCardSavePayload,
} from "../types/mmk";

function normalizePersonalCategoryFromApi(
  value: PersonalCardApi["category"],
): MmkItem["category"] {
  if (value === undefined || value === null) return null;
  if (typeof value === "string" && value.trim() === "") return null;
  return value as MmkCategory;
}

export function mmkItemFromPersonalCardApi(card: PersonalCardApi): MmkItem {
  const shortAnswer = card.short_answer?.trim() || null;
  return {
    id: card.id,
    source: "personal",
    mkk_number: "",
    title: card.question,
    question: card.question,
    content: card.approved_answer,
    approved_answer: card.approved_answer,
    short_answer: shortAnswer,
    category: normalizePersonalCategoryFromApi(card.category),
    status: card.status,
    last_seen_at: card.last_seen_at,
    last_action_at: card.last_action_at,
    is_mastered: card.is_mastered ?? false,
    is_pinned: card.is_pinned,
    is_review_later: card.is_review_later,
  };
}

export function personalMmkItemsToSavePayload(
  items: MmkItem[],
): PersonalCardSavePayload[] {
  return items.map((p) => {
    const shortAnswer = (p.short_answer ?? "").trim();
    return {
      id: p.id,
      question: (p.question ?? p.title ?? "").trim(),
      approved_answer: (p.approved_answer ?? p.content ?? "").trim(),
      short_answer: shortAnswer.length > 0 ? shortAnswer : null,
      category: p.category ?? null,
    };
  });
}
